module.exports = __webpack_public_path__ + "img/thong-sandal.958ed2c5.png";